import styled, { keyframes } from 'styled-components';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Autoplay, Pagination } from 'swiper';
import { getMainVideoReviewList } from './store/action';
import { isObjEmpty } from 'utils/util';

const Review = () => {
  const dispatch = useDispatch();
  const store = useSelector(state => state.reviews);
  const [mode, setMode] = useState('pc');
  const [reviewList, setReviewList] = useState();
  // animation 속도 관리(건수에 따라 속도가 달라지는 현상 보정), default : 33s
  const [animationSpeed, setAnimationSpeed] = useState('33s')
  // 마우스 오버 시 롤링 stop 처리를 위한 변수
  const [isRolling, setIsRolling] = useState(true)

  // 슬라이드 기능
  // mouse over 시 롤링 stop 동작을 위해 cloneNode 방식을 변경함에 따라 미사용
  // const cloneNode = () => {
  //   // 롤링 배너 복제본 생성
  //   let origin = document.querySelector('.wrapper');
  //   origin.id = 'review'; // 아이디 부여

  //   let clone = origin.cloneNode(true);
  //   // cloneNode : 노드 복제. 기본값은 false. 자식 노드까지 복제를 원하면 true 사용
  //   clone.id = 'review_c';
  //   document.querySelector('.viewport').appendChild(clone); // viewport 하위 자식으로 부착

  //   document.querySelector('#review').style.left = '0px';
  //   document.querySelector('#review_c').style.left = document.querySelector('.wrapper').offsetWidth + 'px';
  //   // offsetWidth : 요소의 크기 확인

  //   origin.classList.add('original');
  //   clone.classList.add('clone');
  // }
  
  // PC/Mobile 화면 Resize
  const handleResize = () => {
    setMode(window.innerWidth);
    if(window.innerWidth < 768) {
      setMode('mobile');
    } else {
      setMode('pc');
    }
  };

  /**
   * 화면 로딩 시 메인 영상 리뷰 목록을 읽어온다.
   */
  useEffect(() => {
    dispatch(getMainVideoReviewList())
  }, []);

  /**
   * 메인 영상 리뷰 목록을 읽어오면 렌더링에 사용되는 변수에 저장한다.
   */
  useEffect(() => {
    if (store.mainVideoReviewList) {
      // 슬라이드 수가 증가하더라도 animation 속도가 달라지지 않도록 수정
      // 4개 기준으로 33초로 설정하고 1개가 늘어날때마다 8초를 추가하도록 함
      const listSize = store.mainVideoReviewList.length;
      if (listSize > 4) {
        // 리뷰 갯수가 4개를 넘어갈 경우에만 적용
        const speed = String(33 + (listSize - 4) * 8).concat("s");
        setAnimationSpeed(speed);
      }
      setReviewList(store.mainVideoReviewList);
    }
  }, [store.mainVideoReviewList]);

  /**
   * 리뷰 데이터가 존재하고 pc mode의 경우 swiper slide(슬라이드)를 위한 설정을 진행
   */
  useEffect(() => {
    if (!isObjEmpty(reviewList) && mode === 'pc') {
      // cloneNode();
    }
  }, [reviewList])

  useEffect(()=> {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [window.innerWidth]);

  return (
    <Container>
      <ReviewContainer>
        <Title>고객 후기</Title>
        <ReviewViewPort className='viewport' onMouseEnter={() => setIsRolling(false)} onMouseLeave={() => setIsRolling(true)}>
          {/* <ReviewWrapper className={'wrapper'}> */}
          <ReviewWrapper key='original' className={'wrapper original'.concat(isRolling ? '' : ' stop')} animationSpeed={animationSpeed}>
            { reviewList?.map((item, index) => {
              return (
                <ReviewItem key={index}>
                  <div className='titl'>{item.revwTitl}</div>
                  {/* <div className='cont'>{item.content}</div> */}
                  <div className='cont' dangerouslySetInnerHTML={{ __html: item.revwCtnt }}></div>
                  <div className='wr'>{item.revwrNm}</div>
                </ReviewItem> 
              )
            })}
          </ReviewWrapper>
          <ReviewWrapper key='clone' className={'wrapper clone'.concat(isRolling ? '' : ' stop')} animationSpeed={animationSpeed}>
            { reviewList?.map((item, index) => {
              return (
                <ReviewItem key={index}>
                  <div className='titl'>{item.revwTitl}</div>
                  <div className='cont' dangerouslySetInnerHTML={{ __html: item.revwCtnt }}></div>
                  <div className='wr'>{item.revwrNm}</div>
                </ReviewItem> 
              )
            })}
          </ReviewWrapper>
        </ReviewViewPort>
        {/* 모바일은 Review 데이터를 animation rolling이 아닌 Swiper를 사용*/}
        <ThumbnailSwiper>
          <Swiper
            style={{padding: '8px 0 37px 6px ', margin: '0 10px'}}
            slidesPerView={1}
            pagination={true}
            observer={true}
            observeParents={true}
            spaceBetween={20}
            autoHeight={true}
            onSwiper={(swiper, e) => {
              swiper.autoplay.start()
            }}
            autoplay={{ // 자동 슬라이드 설정, 비 활성화 시 false
              delay: 3500,   // 시간 설정
              disableOnInteraction: false  // false로 설정하면 스와이프 후 자동 재생이 비활성화 되지 않음
            }}
            modules={[Pagination, Autoplay]}
          >
            {reviewList?.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <ReviewItem key={index}>
                    <div className='titl'>{item.revwTitl}</div>
                    <div className='cont'>{item.revwCtnt}</div>
                    <div className='wr'>{item.revwrNm}</div>
                  </ReviewItem> 
                </SwiperSlide>
              )
            })}
          </Swiper>
        </ThumbnailSwiper>
      </ReviewContainer>
    </Container>
  )
}

export default Review;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  background: #F5F5F5;
` 

const ReviewContainer = styled.div`
  height: 748px;
  padding: 180px 0;
  position: relative;

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 60px 16px 55px;
  }
`

const Title = styled.div`
  width: 1088px;
  margin: 0 auto 80px;
  text-align: center;
  font-size: 40px;
  font-weight: 700;
  line-height: 48px;

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    margin-bottom: 17px;
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
  }
`

const originalReview = keyframes`
  0% { transform: translateX(0%); }
	50% { transform: translateX(-100%); }
	50.01% { transform: translateX(100%); }
	100% { transform: translateX(0%); }
`;

const cloneReview = keyframes`
  0% { transform: translateX(0%); }
	100% { transform: translateX(-200%); }
`;

const ReviewViewPort = styled.div`
  display: flex;
  margin: 0 50px 0 50px;
  ::before {
    z-index: 1;
    width: 80px;
    height: 300px;
    position: absolute;
    top: 308px;
    left: 0;
    content:'';
    background: linear-gradient(to right, #F5F5F5, #F5F5F500);
  }
  
  ::after {
    z-index: 1;
    width: 80px;
    height: 300px;
    position: absolute;
    top: 308px;
    right: 0;
    content:'';
    background: linear-gradient(to right,  #F5F5F500, #F5F5F5);
  }
  
  // > * {
  //   &.original {
  //     animation: ${props => props.animationSpeed} linear 0s infinite normal forwards running ${originalReview} ;
  //     // &:hover {
  //     //   animation-play-state: paused, paused;
  //     // }
  //   }
  
  //   &.clone {
  //     animation: ${props => props.animationSpeed} linear 0s infinite normal none running ${cloneReview} ;
  //     // &:hover {
  //     //   animation-play-state: paused, paused;
  //     // }
  //   }
  // }

  @media ${({theme}) => theme.device.mobile} {
    display: none;
  }
`;

const ReviewWrapper = styled.div`
  display: flex;
  position: relative;

  &.original {
    animation: ${originalReview} ${props => props.animationSpeed} linear 0s infinite normal forwards running ;
  }

  &.clone {
    animation: ${cloneReview} ${props => props.animationSpeed} linear 0s infinite normal none running ;
  }

  &.stop {
    animation-play-state: paused;
  }
`;

const ReviewItem = styled.div`
  display: flex;
  flex-direction: column;

  width: 320px;
  height: 300px;
  padding: 30px;
  margin-right: 30px;
  border-radius: 10px;
  background: #FFFFFF;
  box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.15);

  .titl {
    width: 260px;
    margin-bottom: 24px;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
  }
  
  .cont {
    height: 164px;
    color: #4B4B4B;
    font-size: 14px;
    font-weight: 100;
    line-height: 18px;
  }

  .wr {
    margin-top: 18px;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
  }

  @media ${({theme}) => theme.device.mobile} {
    width: 97%;
    margin-right: 0;
    padding: 30px 34px;
  }
`

const ThumbnailSwiper = styled.div`
  display: none;
  @media ${({theme}) => theme.device.mobile} {
    display: block;
    
    // navigation color
    --swiper-theme-color: #FFFFFF;
    
    // swiper bullet color
    .swiper-pagination-bullet {
      width: 10px;
      height: 10px;
      border: 1px solid #D9D9D9;
      background-color: #FFFFFF;
      opacity: 1;
    }
  
    .swiper-pagination-bullet-active {
      background-color: #ABABAC !important;
      border: 1px solid #D9D9D9;
    }
  }
`